import aboutIcon from './about.png';
import aboutDarkIcon from './about_D.png';
import attendeesIcon from './attendees.png';
import attendeesDarkIcon from './attendees_D.png';
import bookmarksIcon from './bookmarks.png';
import bookmarksDarkIcon from './bookmarks_D.png';
import communityIcon from './community.png';
import communityDarkIcon from './community_D.png';
import exhibitorsIcon from './exhibitors.png';
import exhibitorsDarkIcon from './exhibitors_D.png';
import galleryIcon from './gallery.png';
import galleryDarkIcon from './gallery_D.png';
import gamificationIcon from './gamification.png';
import gamificationDarkIcon from './gamification_D.png';
import mapsIcon from './maps.png';
import mapsDarkIcon from './maps_D.png';
import meetingsIcon from './meetings.png';
import meetingsDarkIcon from './meetings_D.png';
import newsIcon from './news.png';
import newsDarkIcon from './news_D.png';
import messagesIcon from './messages.png';
import messagesDarkIcon from './messages_D.png';
import notesIcon from './notes.png';
import notesDarkIcon from './notes_D.png';
import notificationsIcon from './notifications.png';
import notificationsDarkIcon from './notifications_D.png';
import scheduleIcon from './schedule.png';
import scheduleDarkIcon from './schedule_D.png';
import speakersIcon from './speakers.png';
import speakersDarkIcon from './speakers_D.png';
import sponsorsIcon from './sponsors.png';
import sponsorsDarkIcon from './sponsors_D.png';
import socialIcon from './social.png';
import socialDarkIcon from './social_D.png';
import surveyIcon from './survey.png';
import surveyDarkIcon from './survey_D.png';
import webviewIcon from './webview.png';
import webviewDarkIcon from './webview_D.png';
import itineraryIcon from './itinerary.png';
import itineraryDarkIcon from './itinerary_D.png';

export default {
  light: {
    about: aboutIcon,
    attendees: attendeesIcon,
    bookmarks: bookmarksIcon,
    community: communityIcon,
    exhibitors: exhibitorsIcon,
    gallery: galleryIcon,
    gamification: gamificationIcon,
    maps: mapsIcon,
    meetings: meetingsIcon,
    news: newsIcon,
    messages: messagesIcon,
    notes: notesIcon,
    notifications: notificationsIcon,
    schedule: scheduleIcon,
    sponsors: sponsorsIcon,
    social: socialIcon,
    speakers: speakersIcon,
    survey: surveyIcon,
    webview: webviewIcon,
    itinerary: itineraryIcon
  },
  dark: {
    about: aboutDarkIcon,
    attendees: attendeesDarkIcon,
    bookmarks: bookmarksDarkIcon,
    community: communityDarkIcon,
    exhibitors: exhibitorsDarkIcon,
    gallery: galleryDarkIcon,
    gamification: gamificationDarkIcon,
    maps: mapsDarkIcon,
    meetings: meetingsDarkIcon,
    news: newsDarkIcon,
    messages: messagesDarkIcon,
    notes: notesDarkIcon,
    notifications: notificationsDarkIcon,
    schedule: scheduleDarkIcon,
    sponsors: sponsorsDarkIcon,
    social: socialDarkIcon,
    speakers: speakersDarkIcon,
    survey: surveyDarkIcon,
    webview: webviewDarkIcon,
    itinerary: itineraryDarkIcon
  }
};
